@if (!recentOrder() && orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING) {
    <woa-spinner class="order-spinner"></woa-spinner>
}
@if ((recentOrder() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATED) && totalItems()) {
    <div class="order-totals">
        @if (!totalOnly()) {
            @for (discount of initiatedOrder().discounts; track discount; let i = $index) {
                <div class="order-totals-total">
                    <div class="order-totals-total-description" id="discount-label-{{i}}">
                        {{ discount.name }}
                    </div>
                    <div class="order-totals-total-value" id="discount-value-{{i}}">
                        {{ -discount.amount | woaCurrency }}
                    </div>
                </div>
            }
            @for (surcharge of initiatedOrder().surcharges; track surcharge; let i = $index) {
                <div class="order-totals-total">
                    <div class="order-totals-total-description" id="surcharge-label-{{i}}">
                        {{ surcharge.name }}
                    </div>
                    <div class="order-totals-total-value" id="surcharge-value-{{i}}">
                        {{ surcharge.amount | woaCurrency }}
                    </div>
                </div>
            }
            @if (serviceFee()) {
                <div class="order-totals-total">
                    <div class="order-totals-total-description">
                        {{ 'woa.label.order.totals.serviceFee' | translate: {"percentValue": serviceFee().percentValue} }}
                    </div>
                    <div class="order-totals-total-value" id="processing-fee-value">
                        {{ serviceFee().amount | woaCurrency }}
                    </div>
                </div>
            }
            @if ((recentOrder() || orderingContextModel.currentStore()?.allowTips) && (showZeroTip() || tipAmount())) {
                <div class="order-totals-total">
                    <div class="order-totals-total-description" woa-activatable (onActivate)="editTip()">
                        {{ 'woa.label.order.totals.tip' | translate }}
                        @if (canEditTip()) {
                            <woa-link class="order-totals-total-description-action"
                                      [link]="(tipAmount() ? 'woa.button.common.change' : 'woa.button.common.add')"
                                      (onActivate)="editTip()"></woa-link>
                        }
                    </div>
                    <div class="order-totals-total-value" id="tip-value">
                        {{ tipAmount() | woaCurrency }}
                    </div>
                </div>
            }
        }
        <div class="order-totals-total final">
            <div class="order-totals-total-description">
                {{ totalLabel() | translate:{items: totalItems()} }}
            </div>
            <div class="order-totals-total-value" id="total-payment-value">
                {{ totalPayment() | woaCurrency: 'AU$' }}
            </div>
        </div>
        @if (taxAmount()) {
            <div class="order-totals-total">
                <div class="order-totals-total-description">
                    {{ 'woa.label.order.totals.tax' | translate }}
                </div>
                <div class="order-totals-total-value" id="tax-value">
                    {{ taxAmount() | woaCurrency }}
                </div>
            </div>
        }
        @if (showSavings() && !totalOnly() && orderSaving() > 0) {
            <div class="order-totals-total saving">
                <div class="order-totals-total-description">
                    {{ 'woa.label.order.totals.saving' | translate }}
                </div>
                <div class="order-totals-total-value" id="saving-value">
                    {{ orderSaving() | woaCurrency }}
                </div>
            </div>
        }
        @if (canShowPoints()) {
            <div class="order-totals-total">
                <div class="order-totals-total-description"
                     [innerHTML]="pointsLabel() | translate: {points: initiatedOrder().points} | html"></div>
            </div>
        }
        @if (canShowPoints() && initiatedOrder().bonusPoints) {
            <div class="order-totals-total">
                <div class="order-totals-total-description"
                     [innerHTML]="'woa.label.order.totals.bonusPoints' | translate: {points: initiatedOrder().bonusPoints} | html"></div>
            </div>
        }
    </div>
}
